document.addEventListener('DOMContentLoaded', function () {
  const scrollContainer = document.querySelector(
    '.product-list-navigation__list ul'
  )
  const activeLink = document.querySelector(
    '.product-list-navigation__list ul a.s-active'
  )

  if (scrollContainer && activeLink) {
    // (활성 링크의 중간 위치) - (컨테이너의 절반 너비)
    const containerWidth = scrollContainer.offsetWidth
    const linkOffsetLeft = activeLink.offsetLeft
    const linkWidth = activeLink.offsetWidth

    const scrollToPosition = linkOffsetLeft + linkWidth / 2 - containerWidth / 2

    scrollContainer.scrollTo({
      left: scrollToPosition,
      behavior: 'auto',
    })
  }
})
